<template>
    <div style="height: 100%" class="container">
        <a-form layout="inline">
            <a-form-item label="筛选用户">
                <a-select style="width: 150px" v-model="form.layout_id" :allowClear="true">
                    <a-select-option value="">全部区域</a-select-option>
                    <a-select-option v-for="(item, index) in layoutData" :value="item.area_id" :key="index">
                        {{ item.area_name }}
                    </a-select-option>
                </a-select>
            </a-form-item>
            <a-form-item>
                <a-select style="width: 150px" v-model="form.is_seat" :allowClear="true">
                    <a-select-option value="">全部分座状态</a-select-option>
                    <a-select-option value="1">已分座</a-select-option>
                    <a-select-option value="2">未分座</a-select-option>
                </a-select>
            </a-form-item>

            <a-form-item>
                <a-select style="width:150px;" v-model="form.is_RegFee">
                    <a-select-option value="">全部支付状态</a-select-option>
                    <a-select-option value="已交费">已交费</a-select-option>
                    <a-select-option value="未交费">未交费</a-select-option>
                </a-select>
            </a-form-item>
            
            <a-form-item>
                <a-select style="width:150px;" v-model="form.is_reg">
                    <a-select-option value="">全部签到状态</a-select-option>
                    <a-select-option value="已签到">已签到</a-select-option>
                    <a-select-option value="未签到">未签到</a-select-option>
                </a-select>
            </a-form-item>

            <a-form-item>
                <a-input style="width: 150px" placeholder="输入用户名称" v-model="form.name"></a-input>
            </a-form-item>
            <a-form-item>
                <a-input style="width: 150px" placeholder="输入用户单位" v-model="form.company"></a-input>
            </a-form-item>
            <a-form-item>
                <a-input style="width: 150px" placeholder="输入手机号码" v-model="form.mobile"></a-input>
            </a-form-item>
            <a-form-item>
                <a-button @click="handleResetForm">清空筛选条件</a-button>
            </a-form-item>
        </a-form>
        <div class="flex mt10">
            <div>
                <a-button @click="$refs.createUpdatePerson.show(null,null,{layout_id:$route.query.layout_id})" type="primary btn-style">
                    <i class="iconfont icon-jia"></i> 添加用户</a-button>
                <a-button class="ml10" type="primary">
                    <router-link :to="`/area/${$route.params.meeting_id}/${$route.params.hall_id}`"> 座位管理</router-link>
                </a-button>
            </div>
            <a-button @click="handleDelMoreEvent" :disabled="!selectedRowKeys.length" type="danger">批量删除</a-button>
        </div>
    
        <a-table :row-key="(record) => record.id" :loading="tableLoading" class="mt20 table-wrapper" size="small" :bordered="false" :pagination="false" :row-selection="rowSelection" :columns="columns" :data-source="getFilterPersonList">
            <div slot="is_seat" slot-scope="text, record">
                <span class="theme" v-if="record.is_seat == 1">已分配</span>
                <span class="danger" v-if="record.is_seat == 2">未分配</span>
            </div>

            <div slot="action" class="t-l" slot-scope="text, record">
                <a @click="handleEditEvent(record)" href="javascript:;" class="edit-btn iconfont icon-bianji"></a>
                <!-- 未分座的可删除 -->
                <a v-if="record.is_seat != 1" @click="handleRemoveEvent(record)" href="javascript:;" class="del-btn iconfont icon-shanchu"></a>
            </div>
        </a-table>
    
        <create-update-person @ok="getUserList" ref="createUpdatePerson"></create-update-person>
    </div>
</template>

<script>
const columns = [{
        title: '姓名',
        dataIndex: 'name',
    },
    {
        title: '性别',
        dataIndex: 'sex',
    },
    {
        title: '手机号',
        dataIndex: 'mobile',
    },
    {
        title: '邮箱',
        dataIndex: 'email',
    },
    {
        title: '分座状态',
        dataIndex: 'is_seat',
        scopedSlots: { customRender: 'is_seat' },
    },
    {
        title: '签到状态',
        dataIndex: 'is_reg',
        scopedSlots: { customRender: 'is_reg' }
    },
    {
        title: '缴费状态',
        dataIndex: 'is_RegFee',
        scopedSlots: { customRender: 'is_RegFee' }
    },
    {
        title: '单位',
        dataIndex: 'company',
    },
    {
        title: '备注',
        dataIndex: 'remark',
    },
    {
        title: '操作',
        width: 100,
        key: 'action',
        align: "center",
        scopedSlots: { customRender: 'action' },
    },
];
import { mapState } from 'vuex';
import createUpdatePerson from '@/components/createUpdatePerson.vue';
export default {
    name: "Person",
    components: { createUpdatePerson },
    props: {

    },
    data() {
        return {
            columns,
            dataList: [],
            form: {
                name: '',
                company: '',
                layout_id: '',
                mobile: '',
                is_seat: '',
                is_RegFee: '',
                is_reg: ''
            },
            selectedRowKeys: [], // Check here to configure the default column
            tableLoading: true,
        }
    },
    computed: {
        ...mapState(['layoutData']),
        // 表格中是否行的状态
        rowSelection() {
            return {
                onChange: (selectedRowKeys, selectedRows) => {
                    //console.log(`selectedRowKeys:${selectedRowKeys}`, 'selectedRows:', selectedRows);
                    this.selectedRowKeys = selectedRowKeys;
                },
                getCheckboxProps: record => ({
                    props: {
                        disabled: record.is_seat == 1, // Column configuration not to be checked
                        name: record.name,
                    },
                }),
            };
        },
        getFilterPersonList() {
            let personList = this.dataList;
            if (!this.form.name && !this.form.company && !this.form.layout_id && !this.form.mobile && !this.form.is_seat && !this.form.is_RegFee && !this.form.is_reg) {
                return personList;
            } else {
                return personList.filter(person => {
                    if (!this.form.name) {
                        return true;
                    } else {
                        return (person.name && person.name.like(this.form.name)) || (person.pinyin && person.pinyin.like(this.form.name))
                    }
                }).filter(person => {
                    if (!this.form.company) {
                        return true;
                    } else {
                        return person.company && person.company.like(this.form.company)
                    }
                }).filter(person => {
                    if (!this.form.layout_id) {
                        return true;
                    } else {
                        return person.layout_id && person.layout_id == this.form.layout_id;
                    }
                }).filter(person => {
                    if (!this.form.mobile) {
                        return true;
                    } else {
                        return person.mobile && person.mobile.like(this.form.mobile);
                    }
                }).filter(person => {
                    if (!this.form.is_seat) {
                        return true;
                    } else {
                        return person.is_seat && person.is_seat == this.form.is_seat;
                    }
                }).filter(person => {
                    if (!this.form.is_RegFee) {
                        return true
                    } else {
                        return person.is_RegFee && person.is_RegFee == this.form.is_RegFee;
                    }
                }).filter(person => {
                    if (!this.form.is_reg) {
                        return true
                    } else {
                        return person.is_reg && person.is_reg == this.form.is_reg;
                    }
                })
            }
        }
    },
    methods: {
        // 编辑
        handleEditEvent(record) {
            record.user_id = record.id;
            this.$refs.createUpdatePerson.show(record);
        },
        // 单个删除
        handleRemoveEvent(record) {
            this.$confirm({
                title: '温馨提示',
                content: '您确定要删除当前【' + record.name + '】用户吗？',
                onOk: () => {
                    const hide = this.$message.loading('数据请求中...', 0);
                    this.$request.post({ url: "delUser", data: { user_id: record.id, is_seat: 0 } }).then(res => {
                        this.$message.success('移除成功');
                        let index = this.dataList.findItem({ id: record.id }, false);
                        this.dataList.splice(index, 1);
                    }).finally(() => {
                        hide();
                    })
                },
                onCancel() {}
            })
        },
        // 批量删除
        handleDelMoreEvent() {
            this.$confirm({
                title: '温馨提示',
                content: '您确定要删除当前已选择的用户吗？',
                onOk: () => {
                    const hide = this.$message.loading('数据请求中...', 0);
                    this.$request.post({ url: 'delMoreUser', data: { user_id: this.selectedRowKeys } }).then(res => {
                        this.$message.success('移除成功');
                        this.getUserList();
                    }).finally(() => {
                        hide();
                    })
                },
                onCancel() {}
            })
        },
        // 重置
        handleResetForm() {
            for (let key in this.form) {
                this.form[key] = '';
            }
        },
        getUserList() {
            this.$request.post({ url: 'getUserList' }).then(res => {
                this.dataList = res.data;
                this.tableLoading = false;
            })
        },
    },
    mounted() {
        this.form.layout_id = this.$route.query.layout_id || '';
        this.$store.dispatch('getLayoutData').then(res => {
            this.getUserList();
        });

    },
}
</script>

<style lang="less" scoped>
.table-wrapper {
    background-color: #fff;
    max-height: calc(100% - 85px);
    overflow: auto;
    /deep/.ant-table-small {
        th,
        td {
            border-color: #cad4ef !important;
        }
        &>.ant-table-content {
            border: 1px solid #cad4ef;
        }
        &>.ant-table-content>.ant-table-body {
            margin: 0;
        }
        .ant-table-thead {
            background-color: #f1f3ff;
        }
    }
}

.edit-btn,
.del-btn {
    display: inline-block;
    width: 28px;
    height: 28px;
    font-size: 19px;
    line-height: 28px;
    text-align: center;
    border-radius: 4px;
}

.edit-btn {
    color: #19ca8e;
    background-color: #ddf7ee;
}

.del-btn {
    color: #ff4c61;
    margin-left: 5px;
    background-color: #fce3eb;
}
</style>